import { UserWorkspaceProfile } from "@models/UserWorkspaceProfile";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { getSuperiors } from "api/services/user-service";
import { useCallback, useEffect, useState } from "react";

export const useGetSuperiors = () => {
    const { callAPI, loading } = useWorkspaceApiCall(getSuperiors, '', 'getSuperiors.error');

    const fetchSuperiors = useCallback(async () => {
        return await callAPI({});
    }, [callAPI])


    return { fetchSuperiors, loading };
}